export default [
  {
    path: '/transacoes',
    name: 'Lançamento de Cobranças',
    component: () => import('./TransacaoList'),
    meta: {
      routerGo: '/transacoes-new',
      domain: 'Transacoes',
      sidebar: true,
      icon: 'attach_money',
      title: 'Lançamento de Cobranças',
    },
  },
];



// WEBPACK FOOTER //
// ./src/app/Transacoes/TransacoesRouter.js